'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './db-admin-list.routes';

export class DbAdminListComponent {
  constructor(Auth, DBAdminService, dialogs, $stateParams, $uibModal) {
    'ngInject';

    this.DBAdminService = DBAdminService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;
    this.$uibModal = $uibModal;

    this.collection = $stateParams.collection;

    this.dialogs = dialogs;

    this.settings = {
      collections: [
        "users","activationcodes","requestedusers","residencies", "",
        "documents", "calendarevents", "bulletins","news","posts","importantnumbers","businesses","galleries","reservations","",
        "eforms","eformresults","",
        "surveys", "surveyresults", "",
        "mails","recipientlists",
        "pages", "settings", "",
        "storages", "histories", "sessions"],
      colDef: {
        "users": ["_id", "firstName", "lastName", "email"],
        "activationcodes": ["_id", "group", "code", "isTaken"],
        "requestedusers": ["_id", "firstName", "lastName", "email"],
        "residencies": ["_id", "type", "unit", "building"],
        "documents": ["_id", "title", "type", "isPublic"],
        "calendarevents": ["_id", "title", "type", "start"],
        "bulletins": ["_id", "title", "categories", "isPublic"],
        "news": ["_id", "title", "type", "isFeatured", "validUntil"],
        "posts": ["_id", "title", "category", "messageCount"],
        "importantnumbers": ["_id", "name", "number", "category"],
        "businesses": ["_id", "name", "isVendor", "vendorCategory"],
        "galleries": ["_id", "title", "type", "isPublic"],
        "reservations": ["_id", "type", "start", "end", "state"],
        "eformresults": ["_id","form","systemForm","recipients"],
        "eforms": ["_id", "name", "recipients"],
        "surveys": ["_id", "name", "status"],
        "surveyresults": ["_id", "survey"],
        "mails": ["_id", "subject", "type", "sentDate", "template"],
        "recipientlists": ["_id", "name"],
        "pages": ["_id", "name", "isPublic", "isAdminEditable", "type"],
        "settings": ["_id", "name", "isPublic", "tags"],
        "storages": ["_id", "filename", "contentType","storageStrategy", "permission","isPublic", "dataUrl"],
        "histories": ["_id","entityId", "entityType", "action", "actionType"],
        "sessions": ["_id", "expires"]
      }
    };

    this.settings.collections.forEach(c => {
      if (!this.settings.colDef[c])
        this.settings.colDef[c] = ["_id"]
    });

    this.DBAdminService.query({collection: this.collection}, data => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve entities.")
    })

  }

  openPreviewModal(entity) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: entity
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.ap.dbAdmin.list', [uiRouter])
  .config(routes)
  .component('dbAdminList', {
    template: require('./db-admin-list.html'),
    controller: DbAdminListComponent,
    controllerAs: 'ctrl',

  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/superadmin/db/list/db-admin-list.component.js